import { createFileRoute } from '@tanstack/react-router';
import { PublicAppointmentFormPage } from '@/components/appointment-forms/PublicAppointmentFormPage';
import { PublicSignedFormPage } from '@/components/appointment-forms/PublicSignedFormPage';
import {
  isEmbeddedSearchValue,
  parsePublicFormSearch,
  resolvePublicFormSource,
} from '@/lib/forms/public-form-source';

export const Route = createFileRoute('/(public)/form/$id')({
  validateSearch: parsePublicFormSearch,
  component: FormPage,
});

function FormPage() {
  const { id } = Route.useParams();
  const { appointmentId, embed } = Route.useSearch();
  return appointmentId ? (
    <PublicAppointmentFormPage appointmentId={appointmentId} formId={id} />
  ) : (
    <PublicSignedFormPage
      source={resolvePublicFormSource(id)}
      embedded={isEmbeddedSearchValue(embed)}
    />
  );
}
